module.exports = __webpack_public_path__ + "static/img/bannner-placeholder.1fa5b81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bannner-placeholder.jpg
// module id = 8OTm
// module chunks = 45